import { MfeConfig } from '@carvana/microfrontend';
import type { ENV } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';

const config = () =>
  MfeConfig({
    name: 'valueTrackerUi',
    Render: MfeReact(),
    ENV: process.env.NODE_ENV as ENV,
    globals: {
      'styled-components': () => import('styled-components'),
      axios: () => import('axios'),
      Axios: () => import('axios'),
      datadog: () => import('@datadog/browser-rum'),
      JSXRuntime: () => import('react/jsx-runtime'),
      PropTypes: () => import('prop-types'),
      React: () => import('react'),
      ReactDOM: () => import('react-dom'),
      ReactRouterDom: () => import('react-router-dom'),
      StyledComponents: () => import('styled-components'),
      styled: () => import('styled-components')
    }
  });

export default config;
